export default __webpack_public_path__ + "static/panoram_logo.ad9add85.svg";